import css from "./WallArrow.module.css";
import wallArrow from "public/assets/svg/wall-arrow.svg";

import cn from "classnames";

import React from "react";

type WallArrowProps = {
    wallKey: string;
    mirrored?: boolean;
    hidden?: boolean;
};

export const WallArrow: React.FC<WallArrowProps> = ({ wallKey, mirrored, hidden }) => {
    return (
        <div
            className={cn(
                css.main,
                css[`${wallKey}`],
                mirrored && css.mirrored,
                hidden && css.hidden
            )}
        >
            <img src={wallArrow} />
        </div>
    );
};
